<template>
    <footer class="blog-footer">
       <div class="container">
         <div class="kerjasama-antara">
           Kerjasama antara:
         </div>
       </div>
       <div class="container">
         <div class="custom-row logo-footer-area row-footer-logo-1">
            <img src="/images/logo-kementerian-keuangan@3x.jpg">
            <img src="/images/Kementerian BUMN V1.jpg">
            <img src="/images/Kemenkop UKM V1.jpg">
          </div>
          <div class="custom-row logo-footer-area row-footer-logo-2">
            <img src="/images/OJK (Otoritas Jasa Keuangan) vector logo V1.jpg">
            <img src="/images/BPKP V1.jpg">
            <img src="/images/Kejaksaan RI.jpg">
            <img src="/images/Kementerian Dalam Negeri.jpg">
         </div>
       </div>
       <div class="container">
         <div class="kerjasama-antara">
           Didukung sepenuhnya oleh:
         </div>
       </div>
       <div class="container">
         <div class="custom-row logo-footer-area center row-footer-logo-3">
            <img src="/images/logo-kominfo.jpg">
            <img src="/images/logo-bakti@3x.jpg">
         </div>
       </div>
      <!-- <div class="container">
        <div class="row custom-row">
          <div class="col-sm-4 p-0">
              <img class="img-fluid" src="/images/logo-kementerian-keuangan@3x.png">
          </div>
          <div class="col-sm-4 p-0">
                  <img class="img-fluid" src="/images/Kementerian BUMN V1.png">
          </div>
          <div class="col-sm-4 p-0">
              <img class="img-fluid" src="/images/Kemenkop UKM V1.png">
          </div>
        </div>
        <div class="row custom-row">
          <div class="col-sm-3 p-0">
              <img class="img-fluid" src="/images/OJK (Otoritas Jasa Keuangan) vector logo V1.png">
          </div>
          <div class="col-sm-4 p-0">
                  <img class="img-fluid" src="/images/BPKP V1.png">
          </div>
          <div class="col-sm-2 p-0">
              <img class="img-fluid" src="/images/Kejaksaan RI.png" style="margin-bottom:20px;">
          </div>
          <div class="col-sm-1 p-0" style="max-width:6.333% !important;">
              
          </div>
          <div class="col-sm-2 p-0">
              <img class="img-fluid kemdagri" src="/images/Kementerian Dalam Negeri.png">
          </div>
        </div>
         <div class="row custom-row">
          <div class="col-sm-3 p-0">
            <p class="kerjasama-antara">Didukung sepenuhnya oleh:</p>
              <img class="img-fluid" src="/images/logo-bakti@3x.png">
          </div>
        </div>
      </div> -->
    </footer>
</template>

<style>
.logo-footer-area {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.logo-footer-area.center {
  display: flex;
  justify-content: center;
}

.logo-footer-area img {
  /* max-height: 150px; */
  /* margin-bottom: 10px; */
  padding: 0px .8rem;
}

.logo-footer-area.row-footer-logo-1 img {
  max-height: 110px;
}

.logo-footer-area.row-footer-logo-2 img {
  max-height: 95px;
}

.logo-footer-area.row-footer-logo-3 img {
  max-height: 95px;
}

/* ----------------- RESPONSIVE STYLING ----------------- */
@media only screen and (max-width: 319px){
  .logo-footer-area {
    flex-wrap: wrap;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(4) {
    margin-top: 25px;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(3) {
    margin-top: 15px;
  }

  .logo-footer-area.row-footer-logo-3 img:last-child {
    margin-top: 25px;
  }
}
  
@media only screen and (min-width: 320px) and (max-width: 359px){
  .logo-footer-area {
    flex-wrap: wrap;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(4) {
    margin-top: 25px;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(3) {
    margin-top: 15px;
  }
  
  .logo-footer-area.row-footer-logo-3 img:last-child {
    margin-top: 25px;
  }
}
  
@media only screen and (min-width: 360px) and (max-width: 767px) {
  .logo-footer-area {
    flex-direction: column;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(4) {
    margin-top: 25px;
  }

  .logo-footer-area.row-footer-logo-2 img:nth-child(3) {
    margin-top: 15px;
  }

  .logo-footer-area.row-footer-logo-3 img:last-child {
    margin-top: 25px;
  }
}
  
@media only screen and (min-width: 768px) and (max-width: 799px) {
}
  
@media only screen and (min-width: 800px) and (max-width: 899px) {
}

@media only screen and (min-width: 900px) and (max-width: 1023px) {
}
  
@media only screen and (min-width: 1024px) and (max-width: 1259px) {
}

@media only screen and (min-width: 1260px) and (max-width: 1280px) {
}
  
@media only screen and (min-width: 1281px) and (max-width: 1699px) {
}
  
@media only screen and (min-width: 1700px) {
}
</style>

<script>
import EventTracking from '../services/eventTracking'

export default {
    mixins: [EventTracking],
    name: 'Footer',
}
</script>